/**
 * @file 帮助与支持
 * @author wangzhuang
 * */

import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router-dom';

import {fetchHelpapiIndex} from '../../actions/helpAction';

import './index.less';

const tabData = ['产品指南', '更多...'];

export class Help extends Component {
    static propTypes = {
        helpapiIndex: PropTypes.object,
        fetchHelpapiIndex: PropTypes.func,
        history: PropTypes.object
    };

    constructor(props, context) {
        super(props, context);
        this.state = {
            tabIndex: 0
        };
    }

    componentWillMount() {
        if (this.isPC()) {
            location.href = '/help';
        }
    }

    componentDidMount() {
        this.props.fetchHelpapiIndex();
        let menuEl = document.querySelector('#menu');
        menuEl.onclick = e => {
            let domLi = this.findParent(e.target, 'li');
            if (domLi.className === 'on') {
                domLi.classList.remove('on');
                domLi.querySelectorAll('li').forEach(item => {
                    item.classList.remove('on');
                });
            } else {
                domLi.classList.add('on');
            }
        };
    }

    componentWillReceiveProps(nextProps) {
        if (
            nextProps.history.location.pathname === '/'
            && this.props.history.location.pathname !== '/'
            && this.state.menuShow) {

            let liOnList = document.querySelectorAll('li.on');
            liOnList.forEach(item => {
                item.classList.remove('on');
            });
        }
    }

    findParent = (dom, name) => {
        if (dom.tagName.toLowerCase() === name) {
            return dom;
        }
        return this.findParent(dom.parentNode, name);

    };

    renderNav = (navList, num) => {
        let padLeft = (num + 1) * 0.4;
        return <ul className={num === 0 ? 'menu-el' : ''}>
            {
                navList.map((item, index) => {
                    return <li
                        key={index}
                    >
                        {
                            item.flag === 'page'
                                ? <a
                                    href={
                                        `/m/community/${item.url_id}/${item.file_type}/${item.help_type
                                            ? item.help_type
                                            : ''}`
                                    }
                                    className={'menu-el-page'}
                                    style={{paddingLeft: `${padLeft}rem`}}
                                >
                                    {item.name}
                                </a>
                                : ''

                        }

                        {
                            item.flag === 'navigation'
                                ? <div
                                    className={'just-bet'}
                                    style={{paddingLeft: `${padLeft}rem`}}
                                >
                                    <span>{item.name}</span>
                                    <span className={'menu-el-icon'}></span>
                                </div>
                                : ''

                        }

                        {
                            item.flag === 'navigation'
                                ? this.renderNav(item.sub, num + 1)
                                : ''
                        }
                    </li>;
                })
            }
        </ul>;
    };

    render() {
        const helpapiIndex = this.props.helpapiIndex;
        let tabIndex = this.state.tabIndex;

        let menuEl = (
            !this.isEmptyobj(helpapiIndex)
                ? this.renderNav(helpapiIndex.itemlist.help_list, 0)
                : ''
        );

        let mereEl = (
            !this.isEmptyobj(helpapiIndex)
                ? this.renderNav(helpapiIndex.itemlist.brance_list, 0)
                : ''
        );

        return (
            <div className={'spu-help'}>
                <h1>
                    帮助与支持
                </h1>
                <div className={'help-tab align-center'}>
                    {
                        tabData.map((item, index) => {
                            return <div
                                className={tabIndex === index ? 'on' : ''}
                                key={index}
                                onClick={() => {
                                    this.setState({
                                        tabIndex: index
                                    });
                                }}
                            >
                                {item}
                            </div>;
                        })
                    }
                </div>
                <div id={'menu'} className={'menu-box'}>
                    {
                        tabIndex === 0
                            ? menuEl
                            : ''
                    }
                    {
                        tabIndex === 1
                            ? mereEl
                            : ''
                    }
                </div>

            </div>
        );
    }
}

export function mapStateToProps(state) {
    return {
        helpapiIndex: state.helpapiIndex
    };
}

export function mapDispatchToProps(dispatch) {
    return {
        fetchHelpapiIndex: () => fetchHelpapiIndex(dispatch)
    };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Help));



// WEBPACK FOOTER //
// ./src/containers/help/index.js